export default "__VITE_ASSET__ad923fbb__"